/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerBlockElementTypes.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Element Types
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Thursday, September 27, 2018 - 11:47:40 AM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      09/27/2018  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    ELEMENTTYPE_LIST_CONTAINER_LOADED,
    ELEMENTTYPE_LIST_CONTAINER_UNLOADED,
    ELEMENTTYPE_LIST_TABLE_LOADED,
    ELEMENTTYPE_LIST_TABLE_UNLOADED,

    ELEMENTTYPE_SELECT_ROW,
    ELEMENTTYPE_ADD,
    ELEMENTTYPE_EDIT,
    ELEMENTTYPE_DELETE,
    ELEMENTTYPE_OPEN_WARNING,
    ELEMENTTYPE_CLOSE_WARNING,
    
    ELEMENTTYPE_EDIT_CONTAINER_LOADED,
    ELEMENTTYPE_EDIT_CONTAINER_UNLOADED,
    ELEMENTTYPE_EDIT_FORM_LOADED,
    ELEMENTTYPE_EDIT_FORM_UNLOADED,

    ELEMENTTYPE_UPDATE_FIELD,
    ELEMENTTYPE_DRAW_OPTION_SWITCHES,
    ELEMENTTYPE_DRAW_VALIDATION_SWITCHES,
    ELEMENTTYPE_EDIT_FIELDSET_LOADED,

    ELEMENTTYPE_EDIT_DATA_LOAD,
    ELEMENTTYPE_EDIT_CONTAINER_SUBMIT,
    ELEMENTTYPE_EDIT_CONTAINER_CANCEL
} from '../constants/actionTypeBlockElementTypes';

const defaultState = {
    refreshList: false,
    danger: false,
    elementtypeid: 0,
    name: '',
    description: '',
    renderfunction: '',
    fieldsetgroupid: 0,
    fieldsetid: 0,
    elementOptionValues: [],
    elementValidationValues: [],
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case ELEMENTTYPE_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                elementtypes: action.payload[0] ? action.payload[0].records : null
            }
        case ELEMENTTYPE_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case ELEMENTTYPE_SELECT_ROW:
            return {
                ...state,
                elementtypeid: action.id
            }
        case ELEMENTTYPE_ADD:
            return {
                ...state
            }
        case ELEMENTTYPE_EDIT:
            return {
                ...state,
                elementtypeid: action.id
            }
        case ELEMENTTYPE_DELETE:
            return {
                ...state,
                elementtypeid: null
            }
        case ELEMENTTYPE_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case ELEMENTTYPE_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case ELEMENTTYPE_UPDATE_FIELD:
            return {
                ...state, [action.key]: action.value
            };
        case ELEMENTTYPE_DRAW_OPTION_SWITCHES:
            return {
                ...state,
                elementOptionSwitches: action.payload ? action.payload : []
            }
        case ELEMENTTYPE_DRAW_VALIDATION_SWITCHES:
            return {
                ...state,
                elementValidationSwitches: action.payload ? action.payload : []
            }
        case ELEMENTTYPE_EDIT_CONTAINER_LOADED:
            var fsg1 = [{
                'title': 'Please Select A Field Set Group',
                'value': 0,
                'key': 0,
                'disabled': false
            }]
            var fsg2 = action.payload[1] ? action.payload[1].records : []
            var fieldsetgroups = fsg1.concat(fsg2);

            return {
                ...state,
                elementtypeid: action.payload[0] ? action.payload[0].elementtypeid : 0,
                name: action.payload[0] ? action.payload[0].name : '',
                description: action.payload[0] ? action.payload[0].description : '',
                renderfunction: action.payload[0] ? action.payload[0].renderfunction : '',
                fieldsetgroupid: action.payload[0] ? action.payload[0].fieldsetgroupid : '',
                fieldsetid: action.payload[0] ? action.payload[0].fieldsetid : '',
                elementoptions: action.payload[0] ? action.payload[0].elementoptions : [],
                validationoptions: action.payload[0] ? action.payload[0].validationoptions : [],
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : '',
                fieldsetgroups: fieldsetgroups,
                fieldsets: action.payload[2] ? action.payload[2].records : null
            }
        case ELEMENTTYPE_EDIT_DATA_LOAD:
            return {
                ...state,
                elementtypeid: action.payload[0] ? action.payload[0].elementtypeid : 0,
                name: action.payload[0] ? action.payload[0].name : '',
                description: action.payload[0] ? action.payload[0].description : '',
                renderfunction: action.payload[0] ? action.payload[0].renderfunction : '',
                fieldsetgroupid: action.payload[0] ? action.payload[0].fieldsetgroupid : '',
                fieldsetid: action.payload[0] ? action.payload[0].fieldsetid : '',
                elementoptions: action.payload[0] ? action.payload[0].elementoptions : [],
                validationoptions: action.payload[0] ? action.payload[0].validationoptions : [],
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }
        case ELEMENTTYPE_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case ELEMENTTYPE_EDIT_FIELDSET_LOADED:
            return {
                ...state,
                fieldsets: action.payload[0] ? action.payload[0].records : null
            }
        case ELEMENTTYPE_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case ELEMENTTYPE_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case ELEMENTTYPE_LIST_CONTAINER_UNLOADED:
        case ELEMENTTYPE_LIST_TABLE_UNLOADED:
        case ELEMENTTYPE_EDIT_CONTAINER_UNLOADED:
        case ELEMENTTYPE_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/reducerBlockElementTypes.js